module.exports = __webpack_public_path__ + "img/gift4-01-c07-k1.0488b6c9.png";